import React, { useEffect, useRef } from 'react';
import useAnalytics from '../../../../hooks/useAnalytics';
import Logo from '../../../common/Logo/Logo';

export const BoardingPassCard = ({
  boardingPassData,
  homepageData,
  appContent
}) => {
  const isSpaceTheme = boardingPassData.backgroundClass === 'space-theme';

  const { trackBoardingPassRender } = useAnalytics();
  const hasTrackedRef = useRef(false);


  useEffect(() => {
    if (!hasTrackedRef.current) {

      trackBoardingPassRender();
      hasTrackedRef.current = true;
    }
  }, [trackBoardingPassRender]);

  const getLogoSrc = (whiteVersion, blackVersion) =>
    isSpaceTheme
      ? whiteVersion?.url || whiteVersion
      : blackVersion?.url || blackVersion;

  const getLogoAlt = (whiteVersion, blackVersion) =>
    isSpaceTheme
      ? whiteVersion?.alt || 'Logo White'
      : blackVersion?.alt || 'Logo Black';

  return (
    <div className="BoardingPass__boarding-pass" id="boarding-pass-card">
      <div
        className={`boarding-pass-card boarding-pass-card--cutouts ${boardingPassData.backgroundClass}`}
      >
        {/* Top logos section */}
        <div className="slides-topbar-main">
          <div className="logo-group logo-group--main">
            <div className="logo logo-main-container">
              <Logo
                className="logo-main"
                src={getLogoSrc(
                  homepageData?.level_62_logo_simple_white,
                  homepageData?.level_62_logo_simple_black
                )}
                alt={getLogoAlt(
                  homepageData?.level_62_logo_simple_white,
                  homepageData?.level_62_logo_simple_black
                )}
              />
            </div>
          </div>
          <div className="logo-group logo-group--accents">
            <div className="logo logo-accent-container logo-sf">
              <Logo
                className="logo-accent"
                src={getLogoSrc(
                  homepageData?.spaceforce_icon_white,
                  homepageData?.spaceforce_icon_black
                )}
                alt={getLogoAlt(
                  homepageData?.spaceforce_icon_white,
                  homepageData?.spaceforce_icon_black
                )}
                loading="lazy"
              />
            </div>
            <div className="logo logo-accent-container logo-62">
              <Logo
                className="logo-accent"
                src={getLogoSrc(
                  homepageData?.level_62_icon_white,
                  homepageData?.level_62_icon_black
                )}
                alt={getLogoAlt(
                  homepageData?.level_62_icon_white,
                  homepageData?.level_62_icon_black
                )}
                loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* Main content overlay */}
        <div className="boarding-pass-overlay">
          {/* Destinations section */}
          <div className="destinations">
            <div className="info-row">
              <p className="departing">
                Departing from <br />
                <span>{appContent?.acf?.boarding_pass_departing_from}</span>
              </p>
              <div className="destination-arrow">
                <svg
                  width="12"
                  height="8"
                  viewBox="0 0 12 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 4L0 -5.24537e-07L2.39647 4L0.00153732 8L12 4Z"
                    fill="white"
                  />
                </svg>
              </div>
              <p className="arriving">
                Arriving in <br />
                <span>{appContent?.acf?.boarding_pass_arriving_in}</span>
              </p>
            </div>
          </div>

          {/* Passenger section */}
          <div className="passenger-section">
            <div className="passenger-info">
              <div className="info-left">
                <div className="info-row">
                  <span className="label specialty-label">Specialty</span>
                  <span className="patch-name">
                    {boardingPassData.coreValue}
                  </span>
                </div>
                <div className="info-row">
                  <span className="label cv-label">Core Value</span>
                  <span className="patch-name">
                    {boardingPassData.specialty}
                  </span>
                </div>
              </div>
              <div className="info-right">
                <div
                  className={`patch-display ${boardingPassData.patchClass || 'patch-default'}`}
                >
                  {boardingPassData.patchImage && (
                    <img
                      src={boardingPassData.patchImage}
                      alt={boardingPassData.patchName}
                      className="patch-image"
                      onError={(e) => {
                        console.log('Patch image failed to load');
                        e.target.style.display = 'none';
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="boarding-pass-separator"></div>

          {/* Footer section */}
          <div className="boarding-pass-footer">
            <span className="date-time">
              <div className="flight-info">
                <span>Date</span>
                {boardingPassData.date}
              </div>
              <div className="flight-info">
                <span>Boarding Time</span>
                {boardingPassData.time}
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
